import * as z from "zod/v4";

export const ResultSchemaOf = <T extends z.ZodTypeAny, E extends z.ZodTypeAny>(
  value: T,
  error: E,
) => {
  const OkSchema = z.object({
    ok: z.literal(true),
    value,
  });

  const ErrSchema = z.object({
    ok: z.literal(false),
    error,
  });

  return z.discriminatedUnion("ok", [OkSchema, ErrSchema]);
};
